<template>
  <div class="product-bundle" v-if="productbundle">
    <template v-if="productbundle.length > 0">
      <div
        v-for="(bundle,index) in productbundle"
        :key="'stock_'+ index"
        class="z-border-red"
        style="position:relative;padding: 10px;margin-bottom: 15px"
      >
        <add-bundle
          v-model="productbundle[index]"
          :index="index"
          :minBundle="(index > 0 ? (productbundle[index-1].maxquantity ? parseInt(productbundle[index-1].maxquantity) : 0) : null)"
          @onDelete="deleteProductBundle(index,bundle.id)"
          :price="price"
          :lastBundlePrice="(index > 0 ? (productbundle[index-1].price ? parseFloat(productbundle[index-1].price) : 0) : 0)"
        ></add-bundle>
      </div>
    </template>

    <a
      href="javascript:void(0);"
      class="btn-add text-xs-center"
      @click="addProductBundle"
      style="margin-bottom: 15px;padding: 15px 0; text-decoration: none;"
    >
      <span class="fa fa-plus"></span>
      {{$t('Add Price range')}}
    </a>

    <p
      class="text-xs-center caption"
    >{{$t('Wholesale prices will be hidden when the product has a discount')}}</p>
  </div>
</template>

<script>
import AddBundle from './AddBundle'
export default {
  inject: ['$validator'],
  props: {
    value: {
      default: undefined
    },
    price: {
      default: 0,
      type: Number
    }
  },
  data: function() {
    return {
      productbundle: [],
      min: 0,
      max: 999,
      isAdd: false,
      deletelist: []
    }
  },
  components: {
    AddBundle
  },
  mounted: function() {
    if (this.value) {
      this.productbundle = this.value
    }
  },
  methods: {
    addProductBundle: function() {
      let vm = this
      vm.productbundle.push({
        id: null,
        minquantity: null,
        maxquantity: null,
        price: null
      })
    },
    deleteProductBundle: function(index, id) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.$t('Price range') + ' ' + (index + 1)
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            if (id != null) {
              vm.deletelist.push(id)
              vm.$emit('deleteBundle', id)
            }
            vm.productbundle.splice(index, 1)
          }
        })
    }
  },
  watch: {
    productbundle: function() {
      this.$emit('input', this.productbundle)
    },
    value: function() {
      this.productbundle = this.value
    }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ProductBundle.vue